import type { RequestConfig } from '@customTypes/index';
import type { ArtistParametersDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ArtistGetProfileParametersRequest = {
  profileId: string;
};

export type ArtistGetProfileParametersParams =
  RequestConfig<ArtistGetProfileParametersRequest>;

export const artistGetProfileParameters = async ({
  params,
  config
}: ArtistGetProfileParametersParams) =>
  api.get<ArtistParametersDto>(
    `/api/ArtistProfile/${params.profileId}/parameters`,
    config
  );
